import React from 'react';
import { useRouteMatch, useParams, Route } from 'react-router-dom';

import PlatformTeam from '../pages/PlatformTeam/PlatformTeam.tsx';
import PlatformFeatureFlags from '../pages/PlatformFeatureFlags/PlatformFeatureFlags.tsx';
import PlatformActivities from '../pages/PlatformActivities/PlatformActivities';
import PlatformApplications from '../pages/PlatformApplications/PlatformApplications';
import PlatformPolicies from '../pages/PlatformPolicies/PlatformPolicies';
import PlatformNetworks from '../pages/PlatformNetworks/PlatformNetworks';
import PlatformDevices from '../pages/PlatformDevices/PlatformDevices';
import Swg from '../pages/Swgs/Swg/Swg';
import SwgBp from '../pages/Swgs/SwgBp/SwgBp';
import Dpc from '../pages/Dpc/Dpc/Dpc';

import classes from './PlatformRouts.module.scss';

const PlatformRouts = () => {
  let { url } = useRouteMatch();

  const params = useParams();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <div className={classes.platform}>
      <Route path={`${newUrl}/platform/team`}>
        <PlatformTeam customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/applications`}>
        <PlatformApplications customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/activities`}>
        <PlatformActivities customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/policies`}>
        <PlatformPolicies customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/networks`}>
        <PlatformNetworks customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/devices`}>
        <PlatformDevices customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/Swg`}>
        <Swg customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/SwgBp`}>
        <SwgBp customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/dpc`}>
        <Dpc customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/platform/feature-flags`}>
        <PlatformFeatureFlags customerId={params.id} />
      </Route>
    </div>
  );
};

export default PlatformRouts;
